import { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles(() => {
  return {
    root: {
      display: 'flex',
      gap: '10px',
      width: 110,
      height: 24,
      paddingTop: 12,
    },
    ball: {
      width: 12,
      height: 12,
      display: 'inline-block',
      float: 'left',
      borderRadius: '50%',
      animation: '$delay 0.8s infinite ease-in-out',
      '&:nth-child(2)': {
        animationDelay: '-0.7s',
      },
      '&:nth-child(3)': {
        animationDelay: '-0.6s',
      },
      '&:nth-child(4)': {
        animationDelay: '-0.5s',
      },
      '&:nth-child(5)': {
        animationDelay: '-0.4s',
      },
    },
    '@keyframes delay': {
      '0%, 40%, 100%': {
        transform: 'translateY(0)',
        backgroundColor: '#e1e1e1',
      },
      '20%': {
        transform: 'translateY(-10px)',
        backgroundColor: '#888888',
      },
    },
  }
})

interface BounceLoadingProps {
  className?: string
}

const BounceLoading: FC<BounceLoadingProps> = ({ className }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.ball} />
      <div className={classes.ball} />
      <div className={classes.ball} />
      <div className={classes.ball} />
      <div className={classes.ball} />
    </div>
  )
}

export default BounceLoading
